/**
 *
 * Alert
 *
 */

const Alert = ({ kind, title, subtitle, children }) => (
  <div className={`d-flex callout theme-border-${kind}`}>
    {children || (
      <div>
        <div className="icon" />
        <div className="d-flex flex-column">
          <h5>{title}</h5>
          <p>{subtitle}</p>
        </div>
      </div>
    )}
  </div>
)

Alert.defaultProps = {
  title: null,
  subtitle: null,
  kind: 'primary',
}

export default Alert
